/* ====== 业务管理 ===== */

/* 采购管理 -> 采购类型 */
const purchaseType = {
	list:"/purchaseOrderTypemng/purchaseOrderType/list",//列表
	add:"/purchaseOrderTypemng/purchaseOrderType/add",//新增
	edit:"/purchaseOrderTypemng/purchaseOrderType/modify",//编辑
	find:"/purchaseOrderTypemng/purchaseOrderType/find",//查找详情
	del:"/purchaseOrderTypemng/purchaseOrderType/del",//删除
	restore:"/purchaseOrderTypemng/purchaseOrderType/restore"//恢复删除
}


/* 采购管理 -> 采购订单 */
const purchase = {
	list:"/purchasemng/purchaseOrder/list",//列表
	add:"/purchasemng/purchaseOrder/add",//新增
	edit:"/purchasemng/purchaseOrder/modify",//编辑
	find:"/purchasemng/purchaseOrder/find",//查找详情
	del:"/purchasemng/purchaseOrder/del",//删除
	restore:"/purchasemng/purchaseOrder/restore"//恢复删除
}

/* 采购管理 -> 采购入库（进货入库） */
const purchaseinstock = {
	add:'/purchasemng/purchaseinstock/instock',//添加,
	list:'/purchasemng/purchaseinstock/vouchermateriallist',//列表
	find:'/purchasemng/purchaseinstock/find',//详情
	materList:'/purchasemng/purchaseinstock/vouchermateriallist'//物料明细
};
/* /purchasemng/purchasebackstock/backstock */
/* 采购管理 -> 采购退货（进货管理-退货出库） */
const purchasebackstock = {
	add:'/purchasemng/purchasebackstock/backstock',//添加,
	list:'/purchasemng/purchasebackstock/vouchermateriallist',//列表
	find:'/purchasemng/purchasebackstock/find',//详情
};

/* 销售管理 -> 销售出库单 */
const sale = {
	add:'/salemng/saleOutStock/add',//添加,
	//list:'/salemng/saleOutStock/list',//列表
	list:"/salemng/saleOutStock/query",
	find:'/salemng/saleOutStock/find',//详情
};

/* 销售管理 -> 销售退单 */
const salereturn = {
	add:'/salemng/salereturn/add',//添加,
	//list:'/salemng/salereturn/list',//列表
  list:"/salemng/salereturn/query",//列表
	find:'/salemng/salereturn/find',//详情
};

/* 采购管理 -> 采购入库 */
const purchaseRec = {
	list:"/purchasemng/purchaseRec/list",//列表
	add:"/purchasemng/purchaseRec/add",//新增
	edit:"/purchasemng/purchaseRec/modify",//编辑
	find:"/purchasemng/purchaseRec/find",//查找详情
	del:"/purchasemng/purchaseRec/del",//删除
	restore:""//恢复删除
}

/* 采购管理 -> 采购退货 */
const purchaseReturn = {
	list:"/purchasemng/purchaseReturn/list",//列表
	add:"/purchasemng/purchaseReturn/add",//新增
	edit:"/purchasemng/purchaseReturn/modify",//编辑
	find:"/purchasemng/purchaseReturn/find",//查找详情
	del:"/purchasemng/purchaseReturn/del",//删除
	restore:""//恢复删除
}


/* 销售订单 -> 创建销售订单 */
const salesOrder = {
	list:"/mast/materialmng/material/list",//查询物料库存及销售价格列表
	add:"/salemng/saleorder/add",//提交新增订单
	edit:"/salemng/saleorder/modify"//修改订单
}
/* 销售订单 -> 查询销售订单 */
const queryOrder = {
	list:"/salemng/saleorder/salesorderlist",//查找销售订单抬头列表
	find:"/salemng/saleorder/find",//销售订单-查询订单
	del:"/salemng/saleorder/del",//销售订单-刪除销售订单
	restore:"/salemng/saleorder/restore",//销售订单-恢复已删除销售订单
}
/* 销售订单 -> 销售订单收发货 */
const sendOrder = {
	sendout:"/salemng/saleorder/sendout/obtain",//销售订单发货-获取发货销售订单
	check:"/salemng/saleorder/sendout/checksendoutsaleOrder",//销售订单发货-校验销售订单发货信息
	send:"/salemng/saleorder/sendout/sendoutsaleorder"//销售订单发货-销售订单发货
}

/* 销售订单 -> 销售订单退货 */
const CancelOrder = {// 
	CanceOrderSearsh:"/salemng/salesorder/sendback/query",//销售订单退货-获取已发货销售订单
	Cancelout:"/salemng/salesorder/sendback/getspecificsalesorderback",//销售订单退货-获取退货销售订单
	check:"/salemng/salesorder/sendback/saleordereturncheck",//销售订单退货-校验销售订单退货信息
	send:"/salemng/salesorder/sendback/salesordereturn"//销售订单退货-销售订单退货
}
/* 销售订单 -> 查询基本单位列表 */
const targetUnit = {
	list:"/mast/measureUnitmng/measureUnit/list",//计量单位管理-查找计量单位列表

}
/* 销售价格-维护销售价格 */
const salePrice = {
	list:"/salemng/saleprice/list",//销售价格-查询销售订单列表
	add:"/salemng/saleprice/add",//销售价格-添加物料销售价格
	edit:"/salemng/saleprice/modify"//销售价格-修改物料销售价格
}

/* 销售价格-维护芳疗批次特性 */
const batchCharact = {
	add:"/mast/materialmng/mtrlfeature/addfeature",//物料销售特性-添加物料销售特性
	del:"/mast/materialmng/mtrlfeature/del",//物料销售特性-删除物料销售特性
	edit:"/mast/materialmng/mtrlfeature/modifyfeature",//物料销售特性-修改物料销售特性
	list:"/mast/materialmng/mtrlfeature/find",//物料销售特性-查询物料销售特性
	batchCvtPriceUrl:"/mast/materialmng/mtrlfeature/specicvtsaleprice"//批次特性转销售价
}

/* 生产订单管理 -> 创建生产订单 */
const productOrder = {
	add:"/productplan/product/productorder/add",//生产管理-添加生产单
	del:"/productplan/product/productorder/del",//生产管理-删除生产订单
	restore:"/productplan/product/productorder/restore",//生产管理-恢复已删除生产管理订单
	edit:"/productplan/product/productorder/modify",//生产管理-修改生产单
	list:"/productplan/product/productorder/list",//生产管理-查询生产单列表
	check:"/productplan/product/productorder/check",//生产管理-核对信息(ATP)
	find:"/productplan/product/productorder/findproductorder",//生产管理-查询生产单
	bomList:"/productplan/product/productorder/date",//生产管理-BOM信息
	turn:"/productplan/product/productorder/turn",//生产管理-销售订单转生产订单
}
/* 生产订单管理 -> 生产订单出入库 */
const prodOrderInput = {
	input:"/productplan/product/productorderinstock/warehouse",//生产成品入库-生产订单成品入库
	out:"/productplan/product/productorderinstock/partsmtrlout",//生产成品入库-生产订单部件物料出库
}

/* 生产订单管理 -> 生产订单入库反冲 */
const backflush = {
	detail:"/productplan/product/productorderrecoil/detail",//生产成品入库反冲-部件明细
	list:"/productplan/product/productorderrecoil/inrecoillist",//生产成品入库反冲-查询生产订单入库反冲列表
	recoil:"/productplan/product/productorderrecoil/recoil",//生产成品入库反冲-生产订单反冲
}

/* 生产订单管理 -> 生产订单出库反冲 */
const issueBackflush = { 
	list:"/productplan/product/productorderrecoil/outrecoilist",//生产成品出库反冲-查询生产订单部件物料出库反冲列表
	recoil:"/productplan/product/productorderrecoil/componentrecoil",//生产成品入库反冲-生产订单部件物料出库反冲
}

export{
	purchaseType,
	purchase,
	purchaseinstock,
	purchasebackstock,
	sale,
	salereturn,
	purchaseRec,
	purchaseReturn,
	salesOrder,
	queryOrder,
	targetUnit,
	sendOrder,
	CancelOrder,
	salePrice,
	batchCharact,
	productOrder,
	prodOrderInput,
	backflush,
	issueBackflush
}
